import defaultValues from './defaultValues'

const disabled = JSON.parse(defaultValues);

export default disabled;